import { render, staticRenderFns } from "./TransportationPermissionEditor.vue?vue&type=template&id=7660999a"
import script from "./TransportationPermissionEditor.vue?vue&type=script&lang=ts"
export * from "./TransportationPermissionEditor.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports